var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "site-wrap" },
    [
      _c(
        "el-card",
        { attrs: { "body-style": { padding: "0 0 16px" } } },
        [
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _vm._l(_vm.tabs, function (item, index) {
                return [
                  _vm.authList.includes(item.auth)
                    ? _c("el-tab-pane", {
                        key: index,
                        attrs: { label: item.label, name: item.name },
                      })
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "search-wrap" },
        [_c(_vm.componentName, { tag: "component" })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }